import axios from "axios";
import { getHeaders, removeAccessToken } from "functions";

const API_URL = process.env.REACT_APP_API_URL;

async function LogOutUserService(client_id, connection_id) {
    try {
        // console.log(API_URL);
        // console.log(client_id);
        // console.log(connection_id);
        // console.log(getHeaders());
        
        
        const response = await axios.post(
            API_URL + "/logout", {
                client_id: client_id, 
                connection_id: connection_id
            }, {
                headers: getHeaders()
            }
        )
        
        let status = JSON.parse(response.data.user)
        // console.log(status)
        
        
        sessionStorage.removeItem('xf_active_user');
        sessionStorage.removeItem('xf_active_page');
        removeAccessToken()

        return status


    } catch (error) {
        // console.log(error);
        return 'general_error'
    }
}

export default LogOutUserService